var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbicartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.98656496,0,0,1.0033104,-26.383792,183.83238)"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 0.49830145,
    width: 16.204763,
    height: 15.934685,
    x: 26.749458,
    y: 96.852959,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.60169699,0,0,-0.60169699,-144.22065,357.53141)",
    clipPath: "url(#clipPath18-7-5)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18-7-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.28 V 0 H 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.8623,414.1563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-1.035 -0.841,-1.875 -1.876,-1.875 -1.037,0 -1.876,0.84 -1.876,1.875 0,1.036 0.839,1.875 1.876,1.875 C -0.841,1.875 0,1.036 0,0",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.8623,419.9595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-1.036 -0.841,-1.876 -1.876,-1.876 -1.037,0 -1.876,0.84 -1.876,1.876 0,1.036 0.839,1.875 1.876,1.875 C -0.841,1.875 0,1.036 0,0",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.8623,425.8374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-1.036 -0.841,-1.876 -1.876,-1.876 -1.037,0 -1.876,0.84 -1.876,1.876 0,1.036 0.839,1.875 1.876,1.875 C -0.841,1.875 0,1.036 0,0",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291.8105,415.9248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 5.747 H -1.448 V 8.688 H 0 v 3.101 H 3.368 V 8.688 H 6.219 V 5.747 H 3.368 V 0.564 c 0,-0.791 0.339,-1.175 1.109,-1.175 0.632,0 1.199,0.158 1.697,0.429 V -2.941 C 5.449,-3.373 4.612,-3.644 3.458,-3.644 1.354,-3.644 0,-2.807 0,0",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbicartIcon);
export default __webpack_public_path__ + "static/media/AbicartIcon.0caf30c099779838fd457731bd974d12.svg";
export { ForwardRef as ReactComponent };